import { EventEmitter, Injectable, OnDestroy, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertMessage, AlertType } from '@shared/services/alert/alert-message';

/**
 * The alert service manages on-page alert messages.
 */
@Injectable({
  providedIn: 'root',
})
export class AlertService implements OnDestroy {
  private readonly router = inject(Router);

  public readonly alerts = new EventEmitter<AlertMessage | null>();
  private readonly routerEventsSub: Subscription;

  constructor() {
    this.routerEventsSub = this.router.events?.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.clear();
      }
    });
  }

  public ngOnDestroy(): void {
    this.routerEventsSub.unsubscribe();
  }

  /**
   * Raises a success alert
   * @param text The alert text
   */
  public success(text: string): void {
    this.alerts.emit({ type: AlertType.Success, text });
  }

  /**
   * Raises an error alert
   * @param text The alert text
   */
  public error(text: string): void {
    this.alerts.emit({ type: AlertType.Error, text });
  }

  /**
   * Clear all alerts in the queue.
   */
  public clear(): void {
    this.alerts.emit(null);
  }
}
